import React from 'react';
import classNames from 'classnames';

import styles from './ListContainer.module.scss';

interface IListContainerProps extends React.ComponentPropsWithoutRef<'ul'> {}

export function ListContainer({
  children,
  className,
}: IListContainerProps): JSX.Element {
  return <ul className={classNames(styles.list, className)}>{children}</ul>;
}
